export const getOrGenerateSync = (map, fn) => (key, args) => {
    let value = map.get(key);
    if (value !== undefined)
        return value;
    value = fn(key, args);
    map.set(key, value);
    return value;
};
